/** @jsx jsx */

import { jsx } from '@emotion/core';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { createPartnerUserInteractionEventTracker } from 'app/developer-v3/teams/team-partner-sharing/createInteractionTracker';
import { ComponentType } from 'react';

export interface WithPartnerUserInteractionTrackerProps {
  handleTrackInteraction: (info: EventInfo) => void;
}

type EventInfo = {
  eventAction: 'click' | 'copy';
  interactionName: string;
  interactionGoal: string;
};

export const withPartnerUserInteractionTracker = <
  TProps extends WithPartnerUserInteractionTrackerProps
>(
  Component: ComponentType<TProps>
) => {
  return (props: TProps) => {
    // return original component with all the props
    // and handleTrackInteraction
    return <Component {...props} />;
  };
};

function mapStateToProps(
  state: any
): Partial<WithPartnerUserInteractionTrackerProps> {
  const trackInteraction = createPartnerUserInteractionEventTracker(state);
  const handleTrackInteraction = (info: EventInfo) => {
    trackInteraction({ ...info });
  };
  return { handleTrackInteraction };
}

export default compose(
  withPartnerUserInteractionTracker,
  connect(mapStateToProps)
);
